import React from 'react';
import { Box, SvgIcon, useTheme } from '@mui/material';

interface CircularCheckmarkProps {
    filled?: boolean; // Determines whether the checkmark is filled
    size?: number; // Size of the icon
    color?: string; // Optional color for the checkmark
}

const CircularCheckmark: React.FC<CircularCheckmarkProps> = ({ filled, size = 40, color }) => {
    const theme = useTheme();
    const checkmarkColor = color || theme.palette.primary.main;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: size,
                height: size,
                borderRadius: '50%',
                border: `2px solid ${checkmarkColor}`,
                backgroundColor: filled ? checkmarkColor : 'transparent',
                transition: 'background-color 0.3s ease, border-color 0.3s ease',
            }}>
            {filled && (
                <SvgIcon
                    sx={{
                        fontSize: size * 0.6, // Scale the checkmark to fit inside the circle
                        color: '#fff', // White checkmark for filled state
                    }}>
                    <path d="M9 16.2l-4.2-4.2L4.6 10l4.4 4.4L19.4 4.6 20.8 6z" />
                </SvgIcon>
            )}
        </Box>
    );
};

export default CircularCheckmark;
